import { axios } from '/plugins/axios.client';
import { errorFromResponse } from '/src/common/general-utils';
import { i18n } from '/plugins/i18n.client';
const errorHandler = errorFromResponse(i18n.global.t.bind(i18n));
import { toast } from '/plugins/toaster.client.js';

export default {
  /**
   * Gets the list the solution categories
   * @returns {Promise<Array>} list of solution categories.
   */
  async getSolutionCategoriesList() {
    try {
      return await axios.$get('/api/appManager/getSolutionCategories');
    } catch (error) {
      toast.error(errorHandler('admin.applications.actions.fetch_solution_category', error));
      return [];
    }
  },

  /**
   * Deletes the selected solution category
   * @param {string} uuid UUID of the solution category to be deleted.
   */
  async removeSolutionCategory(uuid) {
    try {
      await axios.$delete(`/api/appManager/removeSolutionCategory/${uuid}`);
      toast.success(
        i18n.global.t('admin.dynamic_labels.delete_success', {
          feature: i18n.global.t('admin.feature.application_solution_category')
        })
      );
    } catch (error) {
      toast.error(errorHandler('admin.applications.actions.remove_solution_category', error));
    }
  },

  /**
   * creates the solution category
   * @param { Object } solutionCategory Details of solution category to be created.
   */
  async createSolutionCategory(solutionCategory) {
    try {
      await axios.$post('/api/appManager/createSolutionCategory', solutionCategory);
      toast.success(
        i18n.global.t('admin.dynamic_labels.create_success', {
          feature: i18n.global.t('admin.feature.application_solution_category')
        })
      );
      return true;
    } catch (error) {
      toast.error(
        errorHandler(
          i18n.global.t('admin.dynamic_labels.saving_action', {
            feature: i18n.global.t('admin.feature.application_solution_category')
          }),
          error
        )
      );
      return false;
    }
  },

  /**
   * updates the solution category
   * @param { Object } solutionCategory Details of solution category to be updated.
   * @param {string} uuid UUID of the solution category to be updated.
   */
  async updateSolutionCategory(solutionCategory, uuid) {
    try {
      await axios.$put(`/api/appManager/updateSolutionCategory/${uuid}`, solutionCategory);
      toast.success(
        i18n.global.t('admin.dynamic_labels.update_success', {
          feature: i18n.global.t('admin.feature.application_solution_category')
        })
      );
      return true;
    } catch (error) {
      toast.error(
        errorHandler(
          i18n.global.t('admin.dynamic_labels.saving_action', {
            feature: i18n.global.t('admin.feature.application_solution_category')
          }),
          error
        )
      );
      return false;
    }
  }
};
